document.addEventListener("DOMContentLoaded", () => {
  // Define category names and their corresponding properties
  const categories = [
    { name: "cercei", properties: ["material", "stil"] },
    { name: "coliere", properties: ["material", "stil"] },
    { name: "lanțuri", properties: ["material", "stil"] },
    { name: "inele", properties: ["material", "stil"] },
    { name: "brațari", properties: ["material", "stil"] },
    { name: "pandantive", properties: ["material", "stil"] },
    { name: "toate-bijuteriile", properties: ["material", "stil"] },
    
  ];

  const menuSubCategories = document.querySelectorAll(
    "#x-menu--sub-bijuterii .x-menu--level-2--link:not(:first-of-type) > a"
  );

  const hoverLinks = document.querySelectorAll(
    '.x-menu--level-2--link[data-link-id="bijuterii--categorii"] .x-menu--level-3--link'
  );

  const allColumns = [];

  // Cache DOM queries
  const menuColumns = {};

  categories.forEach((category) => {
    const { name, properties } = category;
    const columnElements = document.querySelectorAll(
      properties
        .map(
          (prop) =>
            `.x-menu--level-2--link[data-link-id="bijuterii--${name}-${prop}"]`
        )
        .join(", ")
    );

    menuColumns[name] = columnElements;

    // Hide menu elements
    columnElements.forEach((el) => el.classList.add("hide"));
    allColumns.push(...columnElements);
  });

  // Remove category name from menu elements
  menuSubCategories.forEach((el) => {
    const text = el.innerText;
    const resultString = text.replace(/.*\s-\s/, "");
    el.innerText = resultString;
  });

  // Event delegation for hover links
  document
    .querySelector(
      '.x-menu--level-2--link[data-link-id="bijuterii--categorii"]'
    )
    .addEventListener("mouseover", (evt) => {
      const target = evt.target.dataset.linkId
        ? evt.target
        : evt.target.closest(".x-menu--level-3--link");
      const targetLinkId = target.dataset.linkId;

      if (categories.some((category) => targetLinkId.includes(category.name))) {
        removeActive();
        categories.forEach(({ name }) => {
          if (targetLinkId === `bijuterii--categorii--${name}`) {
            showColumns(menuColumns[name]);
            target.classList.add("active-menu-link");
          }
        });
      } else {
        closeAll();
        removeActive();
      }

     
    });

    // === NEW SECTION ===
  // When mega menu opens, auto-show first category's columns
  const schmuckSubMenu = document.querySelector('.x-menu--level-2--container');
  if (schmuckSubMenu) {
    // Observe attribute change (Shopify menus toggle height/style)
    const observer = new MutationObserver(() => {

      const isOpen = schmuckSubMenu.style.height && schmuckSubMenu.style.height !== '0px';
 
      if (isOpen) showFirstCategory();
    });
    observer.observe(schmuckSubMenu, { attributes: true, attributeFilter: ['style'] });
  }

  function showFirstCategory() {
    const menuRoot = document.querySelector('.x-menu--level-2--link[data-link-id="bijuterii--categorii"]');
    const firstLink = menuRoot.querySelector('.x-menu--level-3--link');
    if (!firstLink) return;
    const firstId = firstLink.dataset.linkId; // e.g. schmuck--kategorien--ohrringe
    const match = categories.find(c => firstId === `bijuterii--categorii--${c.name}`);
    if (match) {
      removeActive();
      firstLink.classList.add('active-menu-link');
      showColumns(menuColumns[match.name]);
    }
  }
  // === END NEW SECTION ===

   function showColumns(columns) {
        closeAll();
        columns.forEach((el) => el.classList.remove("hide"));
      }

      function closeAll() {
        allColumns.forEach((el) => el.classList.add("hide"));
      }

      function removeActive() {
        hoverLinks.forEach((elem) => {
          elem.classList.remove("active-menu-link");
        });
      }

//Task:LIS-48 - Prevent menu # links from changing url
  document.querySelectorAll("[data-x-menu--depth] a").forEach(function (item) {
    if (item.getAttribute("href") === "#") {
      item.addEventListener("click", function (e) {
        e.preventDefault();
         /*console.log('item click',item.getAttribute("href") );*/
      });
    }else{
     /* console.log('item href',item.getAttribute("href") );*/
    }
  });
});
